<app-doc-viewer title="Message" subtitle="Core">
  <p>Show message to user.</p>

  <li>Import <code>IgoMessageModule</code> only once</li>
  <li>Dependencies: BrowserAnimationsModule</li>

  <app-example-viewer codeFolder="core/message">
    <div class="d-flex m-t-16 actions-container">
      <button mat-raised-button (click)="success()">Success message</button>
      <button mat-raised-button color="primary" (click)="info()">
        Info message
      </button>
      <button mat-raised-button color="accent" (click)="alert()">
        Alert message
      </button>
      <button mat-raised-button color="warn" (click)="error()">
        Error message
      </button>
    </div>
  </app-example-viewer>
</app-doc-viewer>
